import { useEffect, useRef } from "react"
import { useConsentManager } from "@c15t/react"
import { C15tConsentStore } from "cookiesConsent/infrastructure/c15t/consent"
import {
  JurisdictionRules,
  PrivacySignal
} from "cookiesConsent/domain/jurisdiction"

interface SeedDefaultConsentProps {
  rules: JurisdictionRules
  signal: PrivacySignal
  onSettled: () => void
}

const SeedDefaultConsent = ({
  rules,
  signal,
  onSettled
}: SeedDefaultConsentProps) => {
  const manager = useConsentManager()
  const started = useRef(false)

  useEffect(() => {
    if (started.current) {
      return undefined
    } else {
      started.current = true
      new C15tConsentStore(manager).reconcile(rules, signal).finally(onSettled)
      return undefined
    }
  }, [manager, rules, signal, onSettled])

  return null
}

export default SeedDefaultConsent
